// Code generated by apic; DO NOT EDIT.
import React from "react";
import type { SchemaMeta } from "./types";

/**
 * SchemaView renders the fields of a single schema definition.
 *
 * Props:
 *   schema    – the SchemaMeta to display, or null (renders an empty note).
 *   className – extra CSS class appended to the root element.
 *
 * Secret and hash fields are marked with a visual indicator; their VALUES are
 * never rendered (the projection already carries an empty example for them).
 * The component has no side effects and no web-global dependencies at module
 * load time (RN-safe).
 */
export function SchemaView(props: { schema: SchemaMeta | null; className?: string }): JSX.Element {
  const { schema, className } = props;
  const root = ["apic-ui-schema-view", className].filter(Boolean).join(" ");

  if (schema === null) {
    return (
      <div className={root}>
        <span className="apic-ui-schema-empty">{"—"}</span>
      </div>
    );
  }

  return (
    <div className={root}>
      <span className="apic-ui-schema-name">{schema.name}</span>
      <ul className="apic-ui-schema-fields">
        {schema.fields.map((f) => (
          <li key={f.name} className="apic-ui-schema-field">
            <span className="apic-ui-field-name">{f.name}</span>
            <span className="apic-ui-field-type">{f.tsType}</span>
            <span
              className={
                "apic-ui-field-required " +
                (f.required ? "apic-ui-field-required--yes" : "apic-ui-field-required--no")
              }
            >
              {f.required ? "required" : "optional"}
            </span>
            {f.secret && (
              <span className="apic-ui-field-badge apic-ui-field-badge--secret">
                {"secret"}
              </span>
            )}
            {f.hash !== "" && (
              <span className="apic-ui-field-badge apic-ui-field-badge--hash">
                {"hash:" + f.hash}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
